var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-w",attrs:{"id":"app"}},[_c('PageHeader',{attrs:{"getArray":_vm.getArray}}),_vm._v(" "),_c('PageRoute',{attrs:{"getArray":_vm.getArray}}),_vm._v(" "),_c('router-view',{key:_vm.$route.path + _vm.$route.query.t,class:{'con-height':!_vm.isSafari,'con-height-safari':_vm.isSafari}}),_vm._v(" "),_c('PageFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dd5643c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 